interface ClientProfile {
  name: string;
  email: string | null;
  age?: number | null;
  ageRange?: string | null;
  location: {
    city?: string | null;
    state?: string | null;
    zip?: string | null;
  };
  relationship?: string | null;
  reasonForJoining?: string | null;
}

interface ClientDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  clientProfile: ClientProfile | undefined;
  clientAvatar: string;
  ageDisplay: string;
}

const ClientDetailsModal = ({
  isOpen,
  onClose,
  clientProfile,
  clientAvatar,
  ageDisplay,
}: ClientDetailsModalProps) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/25 backdrop-blur-sm px-4"
      style={{ fontFamily: '"Inter", sans-serif' }}
      onClick={handleBackdropClick}
    >
      <div className="relative w-full max-w-[28rem] rounded-[15px] bg-white px-9 py-10 shadow-[0_30px_80px_rgba(15,23,42,0.18)]">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-6 top-6 text-[#9AA3B7] transition-colors hover:text-[#6f778c]"
          aria-label="Close details"
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 5l10 10M15 5L5 15"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div className="mb-8 flex items-center gap-3">
          <div className="h-12 w-12 overflow-hidden rounded-full border border-[#E6D3B1]">
            <img
              src={clientAvatar}
              alt={clientProfile?.name ?? 'Client avatar'}
              className="h-full w-full object-cover"
            />
          </div>
          <div>
            <h3 className="text-xl font-semibold text-[#0F1C39]">
              {clientProfile?.name ?? 'Client'}
            </h3>
            <p className="text-sm text-[#6F7A90]">
              {clientProfile?.relationship ?? '-'}
            </p>
          </div>
        </div>

        <div className="space-y-5">
          {[
            { label: 'Name', value: clientProfile?.name ?? '-' },
            { label: 'Email', value: clientProfile?.email ?? '-' },
            { label: 'Relationship', value: clientProfile?.relationship ?? '-' },
            { label: 'Reason', value: clientProfile?.reasonForJoining ?? '-' },
            {
              label: 'Age Range',
              value: ageDisplay,
            },
            { label: 'ZIP Code', value: clientProfile?.location?.zip ?? '-' },
          ].map((detail) => (
            <div key={detail.label} className="space-y-1">
              <p className="text-sm capitalize font-termina uppercase text-gray-500">
                {detail.label}
              </p>
              <p className="text-lg text-[#111827]">
                {detail.value}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientDetailsModal;

